import { render, staticRenderFns } from "./_HealthShieldCashPlan.vue?vue&type=template&id=70e17467&"
import script from "./_HealthShieldCashPlan.vue?vue&type=script&lang=js&"
export * from "./_HealthShieldCashPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports